import { Left } from 'Models/Menu/menus';
import { ContactsPage } from '@/data/appInformationItems';
import { getView, requireAuth } from '@/lib/utils';

export default {
  path: '/contacts',
  name: 'contacts',
  component: getView('pages/PageContacts'),
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Contacts',
    leftMenu: Left.ContactsList,
    roles: ['operator'],
    information: ContactsPage,
    showBottomMenu: true,
  },
};
